import { useState } from 'react';
import {
  AppBar,
  Box,
  IconButton,
  Link,
  Menu,
  MenuItem,
  Stack,
  Toolbar,
  Typography,
} from '@mui/material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LogoutIcon from '@mui/icons-material/Logout';
import { Link as RouterLink } from 'react-router-dom';
import { useAuthentication } from '@/context/AuthenticationProvider';

const MenuTopBar = () => {
  return (
    <AppBar
      position="fixed"
      sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
    >
      <Toolbar>
        <Stack
          direction="row"
          alignItems="center"
          gap={2}
          flexGrow={1}
          justifyContent="space-between"
        >
          <Link
            component={RouterLink}
            to="/"
            sx={{
              textDecoration: 'none',
              color: 'inherit',
              '&:hover': { color: 'inherit' },
            }}
          >
            <Stack direction="row" gap={1.5} alignItems="center">
              <img src="/favicon.svg" alt="" width="32" height="32" />
              <Typography variant="h6" component="span" noWrap>
                VMS
              </Typography>
              <Typography
                variant="body2"
                component="span"
                sx={{ opacity: 0.75 }}
                noWrap
              >
                Video Metadata Store
              </Typography>
            </Stack>
          </Link>

          <Box sx={{ flexGrow: 1 }} />

          {/* No environment badge here. It said exactly what the drawer footer already says, two
              inches away and on every screen — the drawer is `variant="permanent"`, so that footer is
              never hidden, and it carries the version and commit besides. The badge existed to stop
              someone editing the wrong environment's data; the footer does that job, and one signal
              read twice is one signal, not two. */}
          <AccountMenu />
        </Stack>
      </Toolbar>
    </AppBar>
  );
};

const AccountMenu = () => {
  const { email, groups, signOut } = useAuthentication();
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);

  return (
    <>
      {/* The signed-in email sits on the bar rather than only inside the menu: on a shared demo
          environment "who am I signed in as" is asked far more often than it is acted on, and a menu
          you have to open to answer it is a menu that gets opened constantly. */}
      <Stack direction="row" alignItems="center" gap={1}>
        <Typography
          variant="body2"
          color="text.secondary"
          noWrap
          sx={{ display: { xs: 'none', sm: 'block' }, maxWidth: 220 }}
        >
          {email}
        </Typography>
        <IconButton color="inherit" onClick={(e) => setAnchor(e.currentTarget)}>
          <AccountCircleIcon />
        </IconButton>
      </Stack>
      <Menu
        anchorEl={anchor}
        open={!!anchor}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem disabled sx={{ opacity: '1 !important' }}>
          <Stack>
            <Typography variant="body2">{email ?? 'Signed in'}</Typography>
            <Typography variant="caption" color="text.secondary">
              {groups.length ? groups.join(', ') : 'no groups'}
            </Typography>
          </Stack>
        </MenuItem>
        <MenuItem
          onClick={() => {
            setAnchor(null);
            void signOut();
          }}
        >
          <LogoutIcon fontSize="small" sx={{ mr: 1 }} />
          Sign out
        </MenuItem>
      </Menu>
    </>
  );
};

export default MenuTopBar;
